import { TextField, TextFieldProps } from "@material-ui/core";
import Autocomplete, { AutocompleteProps } from "@material-ui/lab/Autocomplete";
import { lang } from "../../../i18nLang";

export type TOption = {
  id: number | string;
  name: string;
  [property: string]: any;
};

type IProps<Type> = {
  [Property in keyof Type as Exclude<Property, "renderInput">]: Type[Property];
};

type AutoCompleteFieldProps = IProps<
  AutocompleteProps<string | TOption, undefined, boolean, boolean>
> & {
  name: string;
  label?: string;
  onChangeOption?: (name: string, value: TOption) => void;
  InputProps?: TextFieldProps;
  required?: boolean;
};

const AutoCompleteField = ({
  options,
  name,
  label,
  loading = false,
  onChangeOption,
  InputProps = {},
  required,
  ...props
}: AutoCompleteFieldProps) => {
  const handleChangeAutoComplete = (name: string) => (ev, value) => {
    if (onChangeOption) onChangeOption(name, value);
  };

  const handleGetOptionLabel = (option) => option?.name || "";
  const handleGetOptionSelected = (option, value) => option?.id === value?.id;

  return (
    <Autocomplete
      {...props}
      options={options}
      getOptionLabel={handleGetOptionLabel}
      getOptionSelected={handleGetOptionSelected}
      onChange={handleChangeAutoComplete(name)}
      loading={loading}
      loadingText={`${lang("loading")}...`}
      renderInput={(params) => {
        if (!InputProps.fullWidth) {
          let props: any = params.inputProps;
          props.size = props?.value.length;
        }

        return (
          <TextField
            {...params}
            onKeyDown={(ev) => ev.stopPropagation()}
            {...InputProps}
            name={name}
            label={label}
            required={required}
          />
        );
      }}
    />
  );
};

export default AutoCompleteField;
